import styled from "styled-components";

type HeadingProps = {
  children: JSX.Element | JSX.Element[] | string;
  variant: HeadingVariants;
};

export enum HeadingVariants {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  H6 = "h6",
}

const Heading = ({ children, variant }: HeadingProps) => {
  return (
    <StyledHeading as={variant} variant={variant}>
      {children}
    </StyledHeading>
  );
};

const StyledHeading = styled.h1<{ variant: HeadingVariants }>`
  background: ${({ theme }) => theme.colors.linearGradientPrimary};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${({ variant, theme }) => {
    if (variant === HeadingVariants.H1) {
      return theme.fontSize.XL;
    }
    return theme.fontSize.L;
  }};
`;

export default Heading;
